import { css } from '@lastbrand/web-ui-styled-system/css'

// Figma ProductButtonBag (node 8719:17323) stacks message → button → Klarna caption in a column.
// The container deliberately adds NO gap: the Figma 16px (message→button) and 12px (button→caption)
// rhythm is already realized by the children's own spacing (`inStockMessageCss` margin-bottom 16,
// `klarnaWrapperDsClass` padding-top 14 / padding-bottom 8), and this must stay a block-flow div —
// a flex column would change how those existing margins resolve at every call site.
export const containerCss = css({
  width: 'inherit',
  lgDown: { width: 'full' },
})
